import { faBuilding, faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const GLFNavList: MenuItem[] = [
  {
    id: 1,
    name: 'contactInfo',
    componentName: 'ContactInfo',
    complete: false
  },
  {
    id: 2,
    name: 'incomeExpense',
    componentName: 'IncomeExpense',
    complete: false,
    icon: faMoneyBillTrendUp,
    subItems: [
      {
        id: 21,
        name: 'roundsRate',
        confirmNavigation: true,
        complete: false,
        componentName: 'RoundsRate'
      },
      {
        id: 22,
        name: 'revenue',
        confirmNavigation: true,
        componentName: 'RevenueContainer',
        hasTabs: true,
        complete: false,
        subItems: [
          {
            id: 221,
            name: 'GLF.revenue',
            complete: false
          },
          {
            id: 222,
            name: 'GLF.sales',
            complete: false
          },
          {
            id: 223,
            name: 'GLF.nonOperatingIncomeRevenues',
            complete: false
          }
        ]
      },
      {
        id: 23,
        name: 'expenses',
        confirmNavigation: true,
        componentName: 'ExpenseContainer',
        hasTabs: true,
        complete: false,
        subItems: [
          {
            id: 231,
            name: 'GLF.cost',
            complete: false
          },
          {
            id: 232,
            name: 'GLF.expense',
            complete: false
          },

          {
            id: 233,
            name: 'GLF.managementFees',
            complete: false
          },
          {
            id: 234,
            name: 'GLF.charges',
            complete: false
          },
          {
            id: 235,
            name: 'GLF.nonOperatingIncomeExpenses',
            complete: false
          }
        ]
      },
      {
        id: 24,
        name: 'GLF.reserve',
        confirmNavigation: true,
        componentName: 'IncomeAttributeTable',
        complete: false
      },
      {
        id: 25,
        name: 'capitalExpSummary',
        confirmNavigation: true,
        componentName: 'CapitalCostContainer',
        complete: false,
        hasTabs: true,
        subItems: [
          {
            id: 251,
            name: 'GLF.course',
            complete: false
          },
          {
            id: 252,
            name: 'GLF.building',
            complete: false
          },
        ]
      }
    ],
  },
  {
    id: 3,
    name: 'apartment',
    complete: false,
    icon: faBuilding,
    subItems: [
      {
        id: 31,
        name: 'suiteBreakdownTable',
        componentName: 'SuiteBreakdown',
        complete: false
      }
    ]
  },
  {
    id: 4,
    name: 'commercial',
    complete: false,
    icon: faCartShopping,
    subItems: [
      {
        id: 41,
        name: 'leaseInformationTable',
        componentName: 'LeaseInfo',
        complete: false
      },
      {
        id: 42,
        name: 'vacantAskingRate',
        complete: false,
        componentName: 'VacantAskingRate',
      },
      {
        id: 43,
        name: 'parkingSummary',
        complete: false,
        componentName: 'ParkingPropertySummary',
      }
    ]
  },
  {
    id: 5,
    name: 'comments',
    componentName: 'Comment',
    complete: false
  },
  {
    id: 6,
    name: 'summaryReview',
    componentName: 'Summary',
    complete: false,
    icon: faFilePdf
  },
  {
    id: 7,
    name: 'submit',
    componentName: 'Submit',
    complete: false,
    icon: faFileInvoiceDollar
  }
]

export default GLFNavList